// extracted by mini-css-extract-plugin
module.exports =  {"button":"_103a151b99--button--AG5XX","gray":"_103a151b99--gray--DTbPc","red":"_103a151b99--red--iLDj0","blue":"_103a151b99--blue--kCC4y"};